export default function Application() {
  return (
    <section id="application" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-sm text-gray-500 mb-6 tracking-wider">APPLICATION</p>
        <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
          報名方式
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed mb-12">
          少華獎申請將於每年固定時間開放,詳細申請資訊、時程與相關文件,將於官方網站與社群平台公告。
        </p>

        <div className="bg-[#F5F1E8] rounded-3xl p-12 mb-12">
          <div className="grid grid-cols-3 gap-8 mb-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#F4A261] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">準備申請資料</h3>
              <p className="text-sm text-gray-600">包含個人資料、學習計畫與推薦信</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#F4A261] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-send-plane-line text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">線上提交申請</h3>
              <p className="text-sm text-gray-600">於申請期間內完成線上表單填寫</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#F4A261] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">等待通知</h3>
              <p className="text-sm text-gray-600">評選結果將以電子郵件通知</p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#F4A261] text-white text-base font-medium rounded-full hover:bg-[#E89451] transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>立即聯繫我們</span>
            <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center"></i>
          </a>
          <p className="text-sm text-gray-500">
            申請開放時間將另行公告,敬請關注官方消息
          </p>
        </div>
      </div>
    </section>
  );
}
